import { useEffect, useState } from "react";
import { vpAxios, money } from "../api";
import { useNavigate } from "react-router-dom";
import { TrendingUp, ShoppingCart, Store, DollarSign, Plus } from "lucide-react";

export default function HomePage() {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => {
    vpAxios.get("/vaipede/dashboard").then(r => setData(r.data)).catch(() => setData({}));
  }, []);
  if (!data) return <div>Carregando...</div>;

  const cards = [
    { label: "Vendas hoje", value: money(data.vendas_hoje), delta: data.variacao_vs_ontem, icon: DollarSign, color: "text-emerald-600" },
    { label: "Pedidos", value: data.pedidos_hoje ?? 0, icon: ShoppingCart, color: "text-[#EA1D2C]" },
    { label: "Mesas", value: `${data.mesas_ocupadas ?? 0} / ${data.mesas_total ?? 0}`, icon: Store, color: "text-amber-600" },
    { label: "Ticket médio", value: money(data.ticket_medio), icon: TrendingUp, color: "text-blue-600" },
  ];

  return (
    <div data-testid="vaipede-home">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-black">Dashboard</h1>
          <p className="text-sm text-neutral-500">Visão geral da operação</p>
        </div>
        <button onClick={() => nav("/vaipede/dashboard/pdv")} className="px-4 py-2.5 rounded-xl bg-[#EA1D2C] text-white font-bold text-sm flex items-center gap-2 hover:bg-[#c8121f]" data-testid="vaipede-btn-new-order">
          <Plus className="w-4 h-4"/> Novo pedido
        </button>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
        {cards.map(c => (
          <div key={c.label} className="bg-white rounded-2xl border border-neutral-200 p-5">
            <div className="text-xs text-neutral-500">{c.label}</div>
            <div className="text-2xl font-black mt-1">{c.value}</div>
            {typeof c.delta === "number" && (
              <div className={`text-xs mt-1 ${c.delta >= 0 ? "text-emerald-600" : "text-red-600"}`}>
                {c.delta >= 0 ? "↑" : "↓"} {Math.abs(c.delta)}% vs. ontem
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 bg-white rounded-2xl border border-neutral-200 p-5">
          <h2 className="font-bold mb-4">Pedidos recentes</h2>
          {(data.recentes || []).length === 0 && <p className="text-sm text-neutral-500">Nenhum pedido ainda.</p>}
          <div className="divide-y divide-neutral-100">
            {(data.recentes || []).map(p => (
              <div key={p.id} className="py-3 flex items-center justify-between text-sm">
                <div>
                  <div className="font-bold">#{p.numero} <span className="text-neutral-500 font-normal">· {p.cliente_nome || p.tipo}</span></div>
                  <div className="text-xs text-neutral-500">{(p.itens || []).length} itens</div>
                </div>
                <div className="text-right">
                  <div className="font-black text-[#EA1D2C]">{money(p.total)}</div>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-neutral-100">{p.status}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-white rounded-2xl border border-neutral-200 p-5">
          <h2 className="font-bold mb-4">Mais vendidos hoje</h2>
          {(data.mais_vendidos || []).length === 0 && <p className="text-sm text-neutral-500">Sem dados.</p>}
          <div className="space-y-3">
            {(data.mais_vendidos || []).map(p => (
              <div key={p.nome} className="flex items-center justify-between text-sm">
                <span>{p.nome}</span>
                <span className="font-bold">{p.qtd}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
